import React from 'react';
import './GlassSkeleton.css';

interface GlassSkeletonProps {
    width?: string | number;
    height?: string | number;
    borderRadius?: string | number;
    style?: React.CSSProperties;
    className?: string;
    margin?: string | number;
}

/**
 * A highly-reusable Skeleton component that perfectly matches the dark glassmorphism
 * aesthetic of the application. Use this as a placeholder while data is fetching.
 */
export function GlassSkeleton({
    width = '100%',
    height = '1rem',
    borderRadius = '4px',
    margin,
    style,
    className = ''
}: GlassSkeletonProps) {
    return (
        <div
            className={`glass-skeleton-wrapper ${className}`}
            style={{
                width,
                height,
                borderRadius,
                margin,
                ...style
            }}
        />
    );
}
